import PropTypes from 'prop-types';
import React, { Fragment } from 'react';
import { formatPrice } from './quotes/priceFormatter';
import OverallDiscount from './overallDiscount';
import OverallDiscountModal from './OverallDiscountModal';
import classNames from 'classnames';
import { appConfig } from '@ami/react/core';
import Price from './price';

const PriceGeneric = ({
  label,
  msrp,
  price,
  msrpClassNames,
  dNetClassNames,
  onEdit,
  onDelete,
  priceValueClassName,
}) => (
  <div className="row justify-content-end">
    <div className="col-6">
      <h5 className="quote-price-label pull-left me-2">{label}</h5>
      {appConfig.isManagementApp && (
        <Fragment>
          <button type="button" className="btn btn-link p-0" onClick={onEdit}>
            <i className="fa fa-pencil-square-o" />
          </button>
          <button
            type="button"
            className="btn btn-link text-danger p-0 ms-2"
            onClick={onDelete}
          >
            <i className="fa fa-trash" style={{ color: 'red' }} />
          </button>
        </Fragment>
      )}
    </div>
    <h5 className={classNames(priceValueClassName, msrpClassNames)}>{msrp}</h5>
    <h5 className={classNames(priceValueClassName, dNetClassNames)}>{price}</h5>
  </div>
);

export class OverallDiscountsComponent extends React.Component {
  constructor(props) {
    super(props);
    this.modalRef = React.createRef();
  }

  static propTypes = {
    overallDiscounts: PropTypes.arrayOf(PropTypes.instanceOf(OverallDiscount)).isRequired,
    forceVisible: PropTypes.bool.isRequired,
    subTotal: PropTypes.number.isRequired,
    onUpdate: PropTypes.func.isRequired,
    msrpClassNames: PropTypes.string.isRequired,
    dNetClassNames: PropTypes.string.isRequired,
    priceValueClassName: PropTypes.string.isRequired,
    discountSubTotal: PropTypes.number.isRequired,
    discountSubTotalMsrp: PropTypes.number.isRequired,
  };

  removeItem = (index) => {
    const { overallDiscounts, onUpdate } = this.props;
    overallDiscounts.splice(index, 1);
    onUpdate(overallDiscounts);
  };

  addItem = (overallDiscount) => {
    const { overallDiscounts, onUpdate } = this.props;
    onUpdate([...overallDiscounts, overallDiscount]);
  };

  updateItem = (index, overallDiscount) => {
    const { overallDiscounts, onUpdate } = this.props;
    overallDiscounts[index] = overallDiscount;
    onUpdate(overallDiscounts);
  };

  render() {
    const {
      overallDiscounts,
      forceVisible,
      subTotal,
      msrpClassNames,
      dNetClassNames,
      priceValueClassName,
      discountSubTotal,
      discountSubTotalMsrp,
    } = this.props;
    let partialSubTotal = subTotal;
    return (
      <Fragment>
        {overallDiscounts.map((x, idx) => {
          const discountValue = x.getDiscountAmount(partialSubTotal);
          partialSubTotal -= discountValue;
          return (
            <PriceGeneric
              key={idx}
              label={
                x.type === 'Percentage' ? `${x.name} (${x.value}%)` : x.name
              }
              msrp="N/A"
              price={formatPrice(discountValue * -1)}
              msrpClassNames={msrpClassNames}
              dNetClassNames={dNetClassNames}
              priceValueClassName={priceValueClassName}
              onEdit={() => this.modalRef.current.openModal(x, idx)}
              onDelete={() => this.removeItem(idx)}
            />
          );
        })}

        {appConfig.isManagementApp && (
          <Fragment>
            <div className="row justify-content-end">
              <div className={msrpClassNames}></div>
              <div className={dNetClassNames}></div>
            </div>
            <OverallDiscountModal
              ref={this.modalRef}
              onOverallDiscountEdited={(overallDiscount, itemIndex) => {
                if (itemIndex !== undefined) {
                  this.updateItem(itemIndex, overallDiscount);
                } else {
                  this.addItem(overallDiscount);
                }
              }}
            />
          </Fragment>
        )}
        <Price
          label="Subtotal After Discount"
          valueDNet={discountSubTotal}
          valueMsrp={discountSubTotalMsrp}
          hide={!forceVisible && overallDiscounts.length === 0}
          msrpClassNames={msrpClassNames}
          dNetClassNames={dNetClassNames}
        />
      </Fragment>
    );
  }
}
